import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IReSubscribeOtpSendParams, IReSubscribeOtpSendResponse } from '../../../entity';
import ResponseError from '../../entities/errors/ResponseError';
import { IApiPathManager } from '../../../infrastructures/config/ApiPathManager';
import { API_IDS } from '@intigral/constant';

export interface IResubscribeOtpSendUseCase {
    execute(
        payload: IReSubscribeOtpSendParams,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string }
    ): Promise<IReSubscribeOtpSendResponse['data']>;
}

export class ResubscribeOtpSendUseCase implements IResubscribeOtpSendUseCase {
    // Lazy getters for dependencies to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IReSubscribeOtpSendParams,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string }
    ): Promise<IReSubscribeOtpSendResponse['data']> {
        const response = await this.userRepo.resubscribeOtpSend(payload, authToken, authSign, identityToken, csrfToken);

        if (typeof response?.error !== 'undefined') {
            const path = this.apiPathManager.getPath(API_IDS.RESUBSCRIBE_OTP_SEND);
            throw new ResponseError(
                { url: path },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return response.data;
    }
}
